// extracted by mini-css-extract-plugin
module.exports = {"background":"kYCXt","confirm":"V-Sv-","dialogue":"hUzuZ"};